/* eslint-disable no-extra-parens */
/* eslint-disable space-before-function-paren */
const searchBox = document.getElementById('navbar-nav-wrapper');
const searchContainer = document.querySelector('.right-side-btns .relativeDiv--search');
$(searchBox).append(searchContainer);

const contact = document.createElement('a');
contact.classList.add('contact-btn');
contact.id = 'contact-btn';
contact.innerHTML = 'Contact';
contact.href = 'https://www.axway.com/en/contact-us';
document.querySelector('body').appendChild(contact);
const navID = document.querySelectorAll('#block-axway2020-toprightmenu-3')[0];

const searchToggle = document.querySelector('.search-toggle');

if (searchToggle && navID) {
  searchToggle.querySelector('.search-input input').placeholder = 'Search this site';
  searchToggle.querySelector('.search-input input').setAttribute('placeholder', 'Search this site');

  if (window.screen.width > 993) {
    setInterval(function () {
      if (searchToggle.classList.contains('expanded')) {
        navID.querySelector('.expanded').classList.add('hide');
        navID.querySelector('.support').classList.add('hide');
        document.querySelector('.top-nav').classList.remove('disabled');
      } else {
        navID.querySelector('.expanded').classList.remove('hide');
        navID.querySelector('.support').classList.remove('hide');
        document.querySelector('.top-nav').classList.remove('disabled');
      }
    }, 500);
  } else {
    setInterval(function () {
      if (document.querySelector('.search-results-backdrop').classList.contains('loading')) {
        document.querySelector('.mobile-search-header').style.display = 'block';
        document.querySelector('.search-results-backdrop').style.top = '85';
        document.querySelector('.search-results-backdrop').style.zIndex = '99999';
        document.querySelector('.search-results-overlay').style.zIndex = '999999';
      }
    }, 500);
  }
  searchToggle.addEventListener('click', function () {
    document.querySelector('.top-nav').classList.remove('disabled');
    searchToggle.classList.add('expanded');
  });
  searchToggle.querySelector('.search-close span').addEventListener('click', function () {
    searchToggle.classList.remove('expanded');
  });
}
const customLoopFuncCall = (selector, functionCall) => {
  const nodeList = document.querySelectorAll(selector);
  Array.prototype.forEach.call(nodeList, function (node) {
    functionCall(node);
  });
};

// eslint-disable-next-line no-use-before-define
const bindEvents = (element) => element.addEventListener('click', openDropdown);
const unbindEvents = (element) =>
  // eslint-disable-next-line no-use-before-define
  element.removeEventListener('click', openDropdown);
const removeShow = (element) => element.classList.remove('show');
// eslint-disable-next-line no-return-assign
const removeInlineStyles = (element) => (element.style.cssText = '');

const checkForClick = (event) => {
  if (!event.target.parentElement.parentElement.parentElement.classList.contains('dropdown-nav')) {
    document.querySelector('.dropdown-menu.show').classList.remove('show');
    document.removeEventListener('click', checkForClick);
  }
};

const openDropdown = (event) => {
  event.preventDefault();
  event.stopPropagation();

  const target = event.target.nextElementSibling;
  const closeDropdown = (dropdown) =>
    dropdown !== target ? dropdown.classList.remove('show') : null;

  customLoopFuncCall('.dropdown-menu.show', closeDropdown);

  if (target.classList.contains('show')) {
    target.classList.remove('show');
    removeInlineStyles(target);
    document.removeEventListener('click', checkForClick);
  } else {
    target.classList.add('show');
    document.addEventListener('click', checkForClick);
  }
};

const openMobileDropdown = (event) => {
  event.preventDefault();
  const target = document.querySelector('.navbar-collapse');

  const closeDropdown = (dropdown) =>
    dropdown !== target ? dropdown.classList.remove('show') : null;

  customLoopFuncCall('.dropdown-toggle', bindEvents);

  if (target.classList.contains('show')) {
    target.classList.remove('show');
    customLoopFuncCall('.dropdown-menu.show', removeShow);
    customLoopFuncCall('.dropdown-toggle', unbindEvents);
    document.querySelector('body').classList.remove('nav-open');
  } else {
    target.classList.add('show');
    customLoopFuncCall('.dropdown-toggle', bindEvents);
    document.querySelector('body').classList.add('nav-open');
  }
};

const bindNav = () => {
  if (window.screen.width <= 993) {
    customLoopFuncCall('.dropdown-toggle', unbindEvents);
    document.querySelector('.navbar-toggler').removeEventListener('click', openMobileDropdown);

    if (window.matchMedia('(min-width: 993px)').matches) {
      customLoopFuncCall('.dropdown-toggle', bindEvents);
    } else {
      document.querySelector('.navbar-toggler').addEventListener('click', openMobileDropdown);
    }
  }
};

// -- Custom Functions -- //
const customHeaders = () => {
  const noHub = document.querySelector('.hub-page');
  if (!noHub) {
    const headerTxt = document.querySelector('.header-main .primary-logo.txt');
    const currentStream = document.querySelectorAll('.bread-crumbs.item-level a');
    const body = document.querySelector('body');
    if (body.classList.contains('single-page')) {
      headerTxt.textContent = currentStream[`${currentStream.length - 1}`].textContent;
    } else {
      headerTxt.textContent = 'Resource Center';
    }
  }
};

const checkStream = (array) => {
  let match = false;
  array.forEach((item) => {
    if (
      document.body.classList.contains(`stream-${item}`) &&
      document.body.classList.contains('single-page')
    ) {
      match = true;
    }
  });
  return match;
};

const replaceBreadCrumbs = (url) => {
  const homeCrumbs = document.querySelector('.uf-breadcrumb-home');
  if (homeCrumbs) {
    homeCrumbs.setAttribute('href', url);
  }
};

const breadcrumbReplacements = () => {
  const { customBreadcrumbs } = window.obData;
  customBreadcrumbs.forEach((breadCrumb) => {
    const { streamIds, url } = breadCrumb;
    const match = checkStream(streamIds);
    if (match) {
      replaceBreadCrumbs(url);
    }
  });
};

const searchClose = () => {
  const element = document.querySelector('.search-results-overlay');
  const searchCloseButton = document.createElement('a');
  searchCloseButton.classList.add('search-close-btn');
  searchCloseButton.id = 'search-close-btn';
  searchCloseButton.innerHTML = 'Close';
  element.appendChild(searchCloseButton);

  searchCloseButton.addEventListener('click', function () {
    document.querySelector('.search-results-backdrop').style.display = 'none';
    document.querySelector('.search-results-backdrop').style.opacity = '0';
    document.querySelector('.search-results-overlay').style.display = 'none';
    document.querySelector('.search-results-overlay').style.opacity = '0';
  });
};

export {
  customLoopFuncCall,
  openDropdown,
  openMobileDropdown,
  bindNav,
  customHeaders,
  checkStream,
  replaceBreadCrumbs,
  searchClose,
};



// WEBPACK FOOTER //
// ./scriptPartials/tileCustomization.js